import { render, staticRenderFns } from "./addClientWizard.vue?vue&type=template&id=70d43824&scoped=true"
import script from "./addClientWizard.vue?vue&type=script&lang=js"
export * from "./addClientWizard.vue?vue&type=script&lang=js"
import style0 from "./addClientWizard.vue?vue&type=style&index=0&id=70d43824&prod&lang=css"
import style1 from "./addClientWizard.vue?vue&type=style&index=1&id=70d43824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d43824",
  null
  
)

export default component.exports